import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';
import { LibraryElementsModule } from '@app/library/library-elements.module';
import { AbstractContentPane } from '@app/library/panes/models/abstract-content-pane';
import { LibraryCourseMiniComponent } from '@app/library/panes/my-library-courses/library-course-mini/library-course-mini.component';
import { ModalModule } from '@core/components/modal/modal.module';
import { NoContentStubComponent } from '@core/components/no-content-stub/no-content-stub.component';
import { SpinnersModule } from '@core/components/spinners/spinners.module';
import { logger } from '@core/helpers/logger';
import { AccountService } from '@core/services';
import { getMe } from '@store/reducers/profile.reducer';
import { PublishStatusEnum, User, UserService } from 'lingo2-models';
import { OnUiButtonModule, OnUiCoverModule } from 'onclass-ui';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-my-library-courses',
  standalone: true,
  imports: [
    LocaleSharedModule,
    CommonModule,

    SpinnersModule,
    LibraryElementsModule,
    OnUiButtonModule,
    ModalModule,
    OnUiCoverModule,
    NoContentStubComponent,
    LibraryCourseMiniComponent,
  ],
  templateUrl: './my-library-courses.component.html',
  styleUrls: ['./my-library-courses.component.scss', '../../panes/filter-content/filter-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MyLibraryCoursesComponent extends AbstractContentPane implements OnInit {
  public showModal: boolean;
  public categoryTabs = [
    { id: -1, code: 'all', title: 'content.tabs-all' },
    { id: 2, code: PublishStatusEnum.private, title: 'publish-status.private' },
    { id: 3, code: PublishStatusEnum.draft, title: 'publish-status.draft', count: 2 },
    { id: 4, code: PublishStatusEnum.moderation, title: 'publish-status.moderation' },
    { id: 5, code: PublishStatusEnum.archive, title: 'publish-status.archive' },
  ];
  public selectedTab: any = { id: -1 };

  private _me: User;

  public get isAsIfTeacher(): boolean {
    return AccountService.isAsIfTeacher(this._me);
  }

  private publishStatusForAll: string[] = Object.keys(PublishStatusEnum);

  ngOnInit(): void {
    this.store
      .select(getMe)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (me) => {
          this._me = me;
        },
        error: (error) => {
          this.errorNotificationService.captureError(error, 'LOAD-SOMEDATA');
        },
      });
  }

  public onSelectItem(item): void {
    if (this.selectedTab.id === item.id) {
      return;
    }
    this.selectedTab = item;
    const publish_status = item.code === 'all' ? this.publishStatusForAll : [item.code];

    this._pane = {
      ...this._pane,
      loaded: false,
      userServiceFilter: {
        ...this._pane.userServiceFilter,
        publish_status,
      },
      userServices: [],
    };
    this.loadPane();
  }

  protected onContentLoaded() {
    this.isVisible = true;
  }

  hasContent(): boolean {
    return true;
  }

  public onCloseModal(e) {
    logger.log(e);
    this.showModal = !this.showModal;
  }

  public filterUserServiceOnPublishStatus(userService: UserService[]): UserService[] {
    const findFilter = this.categoryTabs.find((tab) => tab.id === this.selectedTab.id);
    if (findFilter.code === 'all') {
      return userService;
    }
    return userService.filter((_c) => _c['publish_status'] === PublishStatusEnum.published);
  }

  public trackByFn(index) {
    return index;
  }
}
